import React from 'react';
// custom imports
import Dashboard from '../Dashboard';
import '../../../assets/css/Profile.css';
// 3rd party imports
import { httpAgent } from '../../httpAgent';
import { message, Button, Input } from 'antd';
const Profile = () => {
    const [dashboardFlag, setDashboardFlag] = React.useState(false);
    const [userNameFlag, setUserNameFlag] = React.useState(false);
    const [loadingFlag, setLoadingFlag] = React.useState(false);
    const userName = React.useRef('');
    const createCanister = async () => {
        setLoadingFlag(true);
        if (userName.current.state.value === '') {
            message.error('Enter User Name');
            setLoadingFlag(false);
        }
        else {
            const game = await httpAgent();
            const checkName = await game.checkUserName(userName.current.state.value);
            if (!checkName) {
                const create = await game.createProfile(userName.current.state.value);
                if (create.length === 1) {
                    localStorage.setItem('userName', userName.current.state.value);
                    setUserNameFlag(false);
                    setLoadingFlag(false);
                    setDashboardFlag(true);
                }
                else {
                    message.error('Something Went Wrong!');
                    setLoadingFlag(false);
                }
            }
            else {
                message.error('Username Already Taken');
                setLoadingFlag(false);
            }
        }
    };
    React.useEffect(() => {
        const createGetProfile = async () => {
            const icdrive = await httpAgent();
            const profile = await icdrive.getProfile();
            // Check if user already exist else create his canister
            if (profile.length === 0) {
                setUserNameFlag(true);
            }
            else {
                localStorage.setItem('userName', profile[0].userName);
                setDashboardFlag(true);
            }
        };
        createGetProfile();
    }, []);
    return (React.createElement("div", { className: "profile-container" },
        React.createElement("div", { id: "bg" },
            React.createElement("img", { src: "./images/back.jpg", alt: "" })),
        dashboardFlag
            ? React.createElement(Dashboard, null)
            : userNameFlag
                ? (React.createElement("div", { className: "innercontainer" },
                    React.createElement("div", { className: "waiting" },
                        React.createElement("div", { style: { paddingTop: '20%' } },
                            React.createElement("span", { id: "username" },
                                "Create Username:\u00A0",
                                React.createElement(Input, { style: { width: '80% !important' }, ref: userName })),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            React.createElement(Button, { type: "primary", loading: loadingFlag, onClick: createCanister }, "Continue")))))
                : (React.createElement("div", { className: "innercontainer" },
                    React.createElement("div", { className: "waiting" },
                        React.createElement("p", { id: "text" }, "Loading..."))))));
};
export default Profile;
